import axios from 'axios'
export default class Redirect {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/redirect/cadBenef`
    this.tokenBearer = tokenBearer
  }
  getCadBenef () {
    return new Promise(async (resolve, reject) => {
      let optionsCadBenef = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseCadBenef = await axios(optionsCadBenef)
        resolve(responseCadBenef)
      } catch (err) {
        reject(err)
      }
    })
  }
  getRedirectNotification (tipoNotificacao) {
    const configs = {
      ANEXO: {
        name: 'minhaunimed',
        tab: 'anexos',
        tabName: 'Anexos',
        subTab: null,
        showModal: true,
        event: null
      },
      ATA_REGISTRADA: {
        name: 'minhaunimed',
        tab: 'anexos',
        tabName: 'Anexos',
        showModal: true,
        subTab: null,
        event: null
      },
      RECIBO: {
        name: 'minhaunimed',
        tab: 'historico',
        tabName: 'Histórico',
        subTab: null,
        event: null,
        showModal: true
      },
      PENDENCIA: {
        name: 'pendencias',
        tabName: 'Pendências',
        tab: null,
        subTab: null,
        event: null,
        showModal: false
      },
      NUMERO_COLABORADORES: {
        name: 'minhaunimed',
        tab: 'perfil',
        tabName: 'Perfil',
        event: 'changeIndexPerfil',
        index: 2,
        tabIndex: 2,
        subTab: null,
        showModal: false
      },
      NUMERO_BENEFICIARIOS: {
        name: 'minhaunimed',
        tab: 'perfil',
        tabName: 'Perfil',
        event: 'changeIndexPerfil',
        index: 0,
        tabIndex: 2,
        subTab: null,
        showModal: false
      },
      NUMERO_COOPERADOS: {
        name: 'minhaunimed',
        tab: 'perfil',
        tabName: 'Perfil',
        event: 'changeIndexPerfil',
        index: 1,
        tabIndex: 2,
        subTab: null,
        showModal: false
      },
      CERTIFICADO_VENCIDO: {
        name: 'minhaunimed',
        tab: 'certificacoes',
        tabName: 'Certificações',
        index: 0,
        tabIndex: 6,
        subTab: null,
        event: 'changeIndexCertificacoes',
        showModal: false
      },
      MANDATO_VENCIDO: {
        name: 'minhaunimed',
        tab: 'mandatos',
        tabName: 'Mandatos',
        subTab: null,
        showModal: false,
        event: null
      },
      CONSELHO_VENCIDO: {
        name: 'minhaunimed',
        tab: 'mandatos',
        tabName: 'Mandatos',
        subTab: null,
        showModal: false,
        event: null
      }
    }
    return configs[tipoNotificacao]
  }
}
